<mat-expansion-panel
    [expanded]="opened === index"
    (opened)="opened = index; childrenLoaded = true"
    (closed)="opened === index && (opened = -1)"
    [disabled]="disabled"
    [ngClass]="{ 'disabled-parent-material-itemform-expansion-panel': !itemForm.value.item_visibility }"
    [class.material-item-wrapper-collapsed]="!expansionPanel.expanded"
    class="parent-material-item"
    #expansionPanel
>
    <mat-expansion-panel-header
        class="on-hover-mat-item"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        <div
            [ngStyle]="{ 'flex-grow': editMode.value ? '1' : 'unset' }"
            fxLayoutGap="5px"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <mat-checkbox [disabled]="true" (click)="$event.stopPropagation()" class="item-checkbox"> </mat-checkbox>
            <span
                *ngIf="!editMode.value"
                (click)="onClearEditMode.emit(true)"
                fxLayoutGap="3px"
                fxLayout="row"
                fxLayoutAlign="start center"
                class="title-item"
            >
                <mat-icon>account_tree</mat-icon>
                <span>{{ itemForm.value.title }}</span>
            </span>
            <mat-form-field class="textarea-title" *ngIf="editMode.value">
                <textarea
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="15"
                    #input
                    matInput
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    type="text"
                    [formControl]="itemForm.get('title') | cast"
                >
                </textarea>
            </mat-form-field>
        </div>
        <div class="tools-wrapper" *ngIf="!editMode.value" fxLayout="row" fxLayoutAlign="start center">
            <ng-container>
                <div class="children-count" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    (
                    <span>{{ childrenItemsCount }}</span>
                    <mat-icon>auto_awesome_motion</mat-icon>
                    )
                </div>
                <button
                    [disabled]="disabled"
                    (click)="$event.stopPropagation(); editMode.next(true)"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Edit title"
                    i18n-matTooltip="@@editTitle"
                >
                    <mat-icon>edit</mat-icon>
                </button>
                <button
                    [disabled]="disabled"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('item_visibility').patchValue(!itemForm.value.item_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.item_visibility
                            ? 'Make it hidden while playing'
                            : 'Make it visible while playing'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.item_visibility ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>

                <button
                    [disabled]="disabled"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('headline_visibility').patchValue(!itemForm.value.headline_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.headline_visibility
                            ? 'Hide headline in playing mode'
                            : 'Show headline in playing mode'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.headline_visibility ? 'format_size' : 'format_clear' }}</mat-icon>
                </button>

                <!-- <button
                    (click)="$event.stopPropagation(); deleteItem(index)"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Delete"
                    i18n-matTooltip="@@delete"
                >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button> -->
                <button
                    [disabled]="!items?.controls?.length"
                    *ngIf="expansionPanel.expanded"
                    (click)="$event.stopPropagation(); handleDisplayMode()"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Manage how material block is taken"
                    i18n-matTooltip="@@manageHowMaterialBlockIsTaken"
                >
                    <mat-icon>vertical_split</mat-icon>
                </button>
                <button
                    mat-icon-button
                    class="tools-btn-icon"
                    (click)="$event.stopPropagation()"
                    [matMenuTriggerFor]="otherToolsMenu"
                    #otherToolsMenuTrigger="matMenuTrigger"
                    i18n-matTooltip="@@otherTools"
                    matTooltip="Other tools"
                >
                    <mat-icon class="kd-icon-24">spoke</mat-icon>
                </button>
                <ng-content *ngIf="!expansionPanel.expanded"></ng-content>
            </ng-container>
        </div>
        <!-- <app-kd-logo-loading size="small"></app-kd-logo-loading> -->
        <button
            *ngIf="editMode.value"
            (click)="
                $event.stopPropagation(); editMode.next(false); onDisableSorting.emit(false); disableSorting.next(false)
            "
            class="tools-btn-icon"
            mat-icon-button
            matTooltip="Confirm"
            i18n-matTooltip="@@confirm"
        >
            <mat-icon>check</mat-icon>
        </button>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        <ng-container *ngIf="childrenItems$ | async as childrenItems">
            <div
                [formGroup]="itemForm"
                class="third-colmn-editor-wrapper mt-1"
                fxFlex="0 1 100%"
                fxLayout="column"
                fxLayoutGap="20px"
            >
                <ng-container *ngIf="host?.parentConnectedList">
                    <!-- Drop area for containers (always present) -->
                    <div
                        class="container-drop-zone"
                        [class.empty-container]="!items?.controls?.length"
                        cdkDropList
                        #bundleItemsList="cdkDropList"
                        [cdkDropListData]="items"
                        [cdkDropListConnectedTo]="[host?.parentConnectedList]"
                        cdkDropListLockAxis="y"
                        (cdkDropListDropped)="drop($event)"
                        (cdkDropListEntered)="onDropListEntered($event)"
                        (cdkDropListExited)="onDropListExited($event)"
                        [class.drag-over-container]="host?.isDragging$ | async"
                    >
                        <mat-accordion
                            *ngIf="!!items?.controls?.length"
                            formArrayName="children_items"
                            class="parent-material-item-wrapper"
                            fxFlex="0 1 100%"
                            fxLayout="column"
                            [multi]="true"
                        >
                            <div
                                cdkDrag
                                cdkDragBoundary=".creta-mat-column"
                                *ngFor="let item of items.controls; let i = index"
                                [formGroupName]="i"
                                [id]="'container-item-' + index + '-' + i"
                                [attr.data-item-index]="i"
                                [attr.data-item-type]="item.value.item_type_value"
                                [attr.data-parent-index]="index"
                                (cdkDragStarted)="onDragStarted($event)"
                                (cdkDragMoved)="onDragMoved($event)"
                                (cdkDragEnded)="onDragEnded()"
                            >
                                <ng-container [ngSwitch]="item.value.item_type_value">
                                    <app-materials-manager-text
                                        *ngSwitchCase="'text_material'"
                                        #materialItemComposer
                                        [index]="i"
                                        [disabled]="item.disabled"
                                        [resource]="resource"
                                        [active]="active && !(isDragging$ | async) && !disableSorting.value"
                                        [itemForm]="item | cast"
                                        [opened]="openedIndex"
                                        (onDisableSorting)="disableSorting.next($event); onDisableSorting.emit($event)"
                                        (onDelete)="delete(item.value.id, i)"
                                        (onCopy)="onCopy.emit($event)"
                                        (onTranslate)="translate({ language_id: $event.language_id, index: i })"
                                        (onRegenerate)="regenerate(item.value, i)"
                                        (onDuplicate)="duplicateChildItem(item.value, i)"
                                        (onSplitText)="splitText($event.blocksCount, $event.index)"
                                        (onAddNewBlock)="onAddNewBlockInContainer($event)"
                                    >
                                        <ng-container
                                            [ngTemplateOutlet]="dragIcon"
                                            [ngTemplateOutletContext]="{ index: i }"
                                        ></ng-container>
                                    </app-materials-manager-text>
                                    <app-materials-manager-link
                                        #materialItemComposer
                                        *ngSwitchCase="'url_material'"
                                        [index]="i"
                                        [disabled]="item.disabled"
                                        [resource]="resource"
                                        [itemForm]="item | cast"
                                        [opened]="openedIndex"
                                        (onDelete)="delete(item.value.id, i)"
                                        (onDisableSorting)="disableSorting.next($event); onDisableSorting.emit($event)"
                                        (onAddNewBlock)="onAddNewBlockInContainer($event)"
                                    >
                                        <ng-container
                                            [ngTemplateOutlet]="dragIcon"
                                            [ngTemplateOutletContext]="{ index: i }"
                                        ></ng-container>
                                    </app-materials-manager-link>

                                    <ng-container
                                        *ngSwitchDefault
                                        [ngTemplateOutlet]="docMaterial"
                                        [ngTemplateOutletContext]="{ i: i, item: item }"
                                    ></ng-container>
                                </ng-container>
                            </div>
                        </mat-accordion>

                        <!-- Empty state content (inside the same drop zone) -->
                        <div *ngIf="!items?.controls?.length" class="empty-drop-placeholder">
                            <mat-icon class="empty-icon">inbox</mat-icon>
                            <span class="empty-text" *ngIf="!(host?.isDragging$ | async)" i18n>No items yet</span>
                            <span class="empty-text drag-hint" *ngIf="host?.isDragging$ | async" i18n
                                >Drop item here</span
                            >
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <app-kd-logo-loading *ngIf="loading$.value" size="small"></app-kd-logo-loading>
    </ng-template>
</mat-expansion-panel>
<ng-template #dragIcon let-index="index">
    <button
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="orderMenu"
        #orderMenuTrigger="matMenuTrigger"
        matTooltip="Sorting / Drag and drop or click"
        i18n-matTooltip
        class="drag-btn"
        cdkDragHandle
        mat-icon-button
    >
        <mat-icon>reorder</mat-icon>
    </button>

    <mat-menu
        #orderMenu="matMenu"
        class="passing-menu-panel correct-alt-menu"
        [hasBackdrop]="true"
        [overlapTrigger]="false"
    >
        <div fxLayout="column" fxLayoutAlign="start start" class="sorting-prio-menu">
            <span i18n>Sorting priority</span>
            <mat-form-field class="passing-data">
                <mat-label i18n>Enter sorting priority</mat-label>
                <input
                    matInput
                    type="number"
                    min="0"
                    [formControl]="sortingPrio | cast"
                    (click)="$event.stopPropagation()"
                />
            </mat-form-field>
            <button
                color="primary"
                mat-button
                [disabled]="sortingPrio.value == null || sortingPrio.value == 0"
                (click)="orderMenuTrigger.closeMenu(); onSortPopup(index, sortingPrio.value - 1); sortingPrio.reset()"
                matMenuClose
            >
                <span i18n>Done</span>
            </button>
        </div>
    </mat-menu>
</ng-template>
<ng-template #docMaterial let-i="i" let-item="item">
    <app-materials-manager-file
        #materialItemComposer
        [index]="i"
        [disabled]="item.disabled"
        [resource]="resource"
        [itemForm]="item | cast"
        [opened]="openedIndex"
        (onDelete)="delete(item.value.id, i)"
        (onDisableSorting)="disableSorting.next($event); onDisableSorting.emit($event)"
        (onAddNewBlock)="onAddNewBlockInContainer($event)"
    >
        <ng-container [ngTemplateOutlet]="dragIcon" [ngTemplateOutletContext]="{ index: i }"></ng-container>
    </app-materials-manager-file>
</ng-template>
<mat-menu
    #otherToolsMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="other-tools-menu-backdrop"
>
    <button
        *ngIf="!isEditInBottomSheet"
        mat-icon-button
        class="tools-btn-icon other-tools-btn"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="addNewBlockMenu"
        #addNewBlockMenuTrigger="matMenuTrigger"
        i18n-matTooltip="@@otherTools"
        matTooltip="Other tools"
    >
        <mat-icon>add</mat-icon>
        <span i18n>Add new block</span>
        <mat-icon>expand_more</mat-icon>
    </button>
    <button
        [disabled]="
            (expansionPanel.expanded && !items?.controls?.length) || (!expansionPanel.expanded && !childrenIds?.length)
        "
        (click)="download(); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn"
        mat-button
    >
        <mat-icon>save_alt</mat-icon>
        <span i18n>Download</span>
    </button>
    <button (click)="deleteItem(index); otherToolsMenuTrigger.closeMenu()" class="tools-btn" mat-button>
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span i18n>Delete</span>
    </button>
</mat-menu>
<mat-menu
    #addNewBlockMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="add-new-block-menu-backdrop"
>
    <button
        (click)="onAddNewBlockInContainer({ index: index, blockType: 'text' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>post_add</mat-icon>
        <span i18n>Text block</span>
    </button>
    <button
        (click)="onAddNewBlockInContainer({ index: index, blockType: 'image' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_photo_alternate</mat-icon>
        <span i18n>Image block</span>
    </button>
    <!-- <button
        (click)="onAddNewBlockInContainer({ index: index, blockType: 'file' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>cloud_upload</mat-icon>
        <span i18n>Upload file</span>
    </button> -->
    <button
        (click)="onAddNewBlockInContainer({ index: index, blockType: 'link' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_link</mat-icon>
        <span i18n>Link block</span>
    </button>
</mat-menu>
